import store from '@/store'
import i18n from '@/locales'

const DOMAIN_ADMIN_ROLES = ['admin', 'domainadmin']
const ROLES = [
  'admin',
  'domainadmin',
  'project_owner',
  'domain_editor',
  'project_editor',
  'ai_admin',
  'ai_edtior',
  'ai_viewer',
]

export default {
  index: 55,
  meta: {
    label: i18n.t('mlops.menu'),
    icon: 'navbar-view-switch',
    catalog: 'mlops',
  },
  menus: [
    {
      meta: {
        label: i18n.t('mlops.router.overview'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/ecs/user',
          meta: {
            label: i18n.t('mlops.router.overview'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.aiMarket'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/market',
          meta: {
            label: i18n.t('mlops.router.computeMarket'),
          },
        },
        {
          path: '/llm/maas/models',
          meta: {
            label: i18n.t('mlops.router.modelMarket'),
          },
        },
        {
          path: '/llm/maas/trial',
          meta: {
            label: i18n.t('mlops.router.experienceCenter'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.trainAndInference'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/ecs/instances',
          meta: {
            label: i18n.t('mlops.router.containerInstance'),
          },
        },
        {
          path: '/llm/train/tasks',
          meta: {
            label: i18n.t('mlops.router.trainTask'),
          },
        },
        {
          path: '/llm/train/templates',
          meta: {
            label: i18n.t('mlops.router.trainTemplate'),
          },
        },
        {
          path: '/llm/deploy/deployments',
          meta: {
            label: i18n.t('mlops.router.inferenceService'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.aiAssets'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/ecs/datasets',
          meta: {
            label: i18n.t('mlops.router.dataset'),
          },
        },
        {
          path: '/llm/ecs/models',
          meta: {
            label: i18n.t('mlops.router.modelManage'),
          },
        },
        {
          path: '/llm/ecs/images',
          meta: {
            label: i18n.t('mlops.router.containerImage'),
          },
        },
        {
          path: '/llm/ecs/repositories',
          meta: {
            label: i18n.t('mlops.router.repository'),
          },
        },
        {
          path: '/llm/ecs/disks',
          meta: {
            label: i18n.t('mlops.router.diskStorage'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.resourceManage'),
        roles: DOMAIN_ADMIN_ROLES,
      },
      submenus: [
        {
          path: '/llm/ecs/resources',
          meta: {
            label: i18n.t('mlops.router.dedicatedResource'),
            roles: DOMAIN_ADMIN_ROLES,
          },
        },
        {
          path: '/llm/ecs/resource_quotas',
          meta: {
            label: i18n.t('mlops.router.resourceQuota'),
            roles: DOMAIN_ADMIN_ROLES,
          },
        },
        {
          path: '/llm/ecs/resource_monitor',
          meta: {
            label: i18n.t('mlops.router.resourceMonitor'),
            roles: DOMAIN_ADMIN_ROLES,
          },
        },
        {
          path: '/llm/ecs/audit_logs',
          meta: {
            label: i18n.t('mlops.router.resourceAudit'),
            roles: DOMAIN_ADMIN_ROLES,
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.modelService'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/maas/statistics',
          meta: {
            label: i18n.t('mlops.router.usageStatistics'),
          },
        },
        {
          path: '/llm/maas/model-service-prices',
          meta: {
            label: i18n.t('mlops.router.serviceList'),
          },
        },
        {
          path: '/llm/maas/apiKey',
          meta: {
            label: i18n.t('mlops.router.apiKey'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('mlops.router.systemSetting'),
        hidden: () => !store.getters.isAdminMode,
      },
      submenus: [
        {
          path: '/llm/ecs/clusters',
          meta: {
            label: i18n.t('mlops.router.computeCluster'),
            roles: ['admin'],
          },
        },
        {
          path: '/llm/ecs/storage_clusters',
          meta: {
            label: i18n.t('mlops.router.storageCluster'),
            roles: ['admin'],
          },
        },
        // {
        //   path: '/llm/maas/model-manage',
        //   meta: {
        //     label: i18n.t('mlops.router.modelServiceSetting'),
        //     roles: ['admin'],
        //   },
        // },
      ],
    },
  ],
}
